import * as MediaQuery from 'react-responsive';
import * as React from 'react';

import {ClockWithTimezone, chinaTimezone, idTimezone, indiaTimezone, krTimezone, usTimezone} from './Clock';
import { Partner, StudioSessionToken } from 'glance-datatypes';

import Avatar from 'material-ui/Avatar';
import DropDownMenu from 'material-ui/DropDownMenu';
import { Link } from 'react-router';
import MenuItem from 'material-ui/MenuItem';
import { connect } from 'react-redux';
import  { get } from 'lodash';

const styles = {
    mainDiv : {
        display: 'flex',
        flexDirection: 'row',
        height: 'inherit',
    },
    title: {
        color: 'white',
        display: 'inline-block',
        float: 'left',
        fontWeight: 400,
        marginTop: '15px',
    },
    partnerMenu: {
        color: 'white',
        display: 'inline-block',
        float: 'left',
        fontWeight: 400,
        marginTop: '2px',
        marginLeft: '-10px',
        fontSize: '24px',
    },
    clockDiv: {
        display: 'inline-block',
        margin: '0 auto',
        // float: 'right'
    },
    clockSpan: {
        fontSize: '16px',
        display: 'inline-block',
        margin: '0 10px',
    },
    userPic: {
        display: 'inline-block',
        float: 'right',
        // backgroundColor: cyan700
    },
    userName : {
        fontSize: '20px',
        paddingRight: '12px',
    },
    fontIcon: {
        verticalAlign: 'middle',
    },
};

interface Props {
    history?: any;
    title: string;
    user?: StudioSessionToken;
    partner: Partner;
    partnerMap: Map<string, Partner>;
}


class CustomAppBar extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);
        this.changePartner = this.changePartner.bind(this);
    }

    render() {
        const {user, partner = { partnerId: '',name: '' }, partnerMap, title} = this.props;
        const pictureUrl = get(user, 'user.pictureUrl', '');
        const name = get(user, 'user.name', '');


        const avatar = pictureUrl ?
                    <Avatar src={pictureUrl}/> :
                    <Avatar> {name.substr(0,1)} </Avatar>;

        let partnerMenuItems = [];
        partnerMap.forEach((partnerItem: Partner) => {
            if (partnerItem.partnerId !== partner.partnerId) {
                partnerMenuItems.push(
                    <MenuItem
                        containerElement={<Link to={'/partner/' + partnerItem.partnerId}/>}
                        primaryText={partnerItem.name}
                        onClick={() => this.changePartner(partnerItem.partnerId)}
                        value={partnerItem.partnerId}
                    />,
                );
            }
        });
        return (
            <div>
            <MediaQuery query='(min-device-width: 1224px)'>
                <div style={styles.mainDiv}>
                    <h3 style={styles.title}>{title}</h3>
                    {
                        partner && partner.partnerId ?
                        <DropDownMenu value={1} labelStyle={styles.partnerMenu}>
                            <MenuItem
                                value={1}
                                containerElement={<Link to={'/partner/' + partner.partnerId}/>}
                                primaryText={partner.name}
                                onClick={() => this.changePartner(partner.partnerId)}
                            />
                            {partnerMenuItems}
                        </DropDownMenu>
                        : null
                    }
                        <div style={styles.clockDiv}>
                            <ClockWithTimezone timezone={usTimezone} customStyle={styles.clockSpan} />
                            <ClockWithTimezone timezone={indiaTimezone} customStyle={styles.clockSpan} />
                            <ClockWithTimezone timezone={chinaTimezone} customStyle={styles.clockSpan} />
                            <ClockWithTimezone timezone={krTimezone} customStyle={styles.clockSpan} />
                            <ClockWithTimezone timezone={idTimezone} customStyle={styles.clockSpan} />

                        </div>
                        <div style={styles.userPic}>
                            <span style={styles.userName}>{name}</span>
                            {avatar}
                        </div>

                </div>
            </MediaQuery>
            <MediaQuery query='(max-device-width: 1224px)'>
                <div style={styles.mainDiv}>
                    <h3 style={styles.title}>{title}</h3>
                    {
                        partner?
                        <DropDownMenu value={1} labelStyle={styles.partnerMenu}>
                            <MenuItem
                                value={1}
                                containerElement={<Link to={'/partner/' + partner.partnerId}/>}
                                primaryText={partner.name}
                                onClick={() => this.changePartner(partner.partnerId)}
                            />
                            {partnerMenuItems}
                        </DropDownMenu>
                        : ''
                    }
                     <div style={styles.clockDiv}>
                         </div>
                    <div style={styles.userPic}>
                        {avatar}
                    </div>

                </div>
            </MediaQuery>
            </div>
        );
    }
    changePartner(value: string) {
        this.props.history.push('/partner/' + value);
        window.location.reload();
    }
}


const mapStateToProps = (state) => {
    return {
        studioAppConfig: state.studioAppConfig,
    };
};


export default connect(mapStateToProps)(CustomAppBar);




// WEBPACK FOOTER //
// ./src/components/CustomAppBar.tsx